module.exports = __webpack_public_path__ + "static/media/Page18.d8712eb0.png";